



























































import { Component, Prop, Ref, Vue } from "vue-property-decorator";
import MiraLandingFiguresDialogComponent from "@/components/mira/MiraLandingFiguresDialog.vue";
import { MiraSection, MiraSectionDocument } from "@/data/models/Mira";
import { MiraCoverageStatus, MiraSectionUnlocks } from "@/utils/MiraDataQuality";
import { miraStatusColor } from "@/utils/MiraDataQualityView";
import { mayEditMiraLandingChoice, miraLandingChoice } from "@/utils/MiraLandingChoice";
import { MIRA_SECTION_ICONS } from "@/utils/MiraOverview";

/**
 * "Was weitere Kennzahlen freischaltet": the figures hidden in the chosen period, one card per
 * section, each with its name and what the company would have to record.
 *
 * The wording is Office's, keyed by metric id. A metric Office has no key for yet (one Cloud adds
 * later) shows its id and a generic line, checked with `$te`, so a raw key never reaches the screen.
 */
@Component({
  components: {
    "mira-landing-figures-dialog": MiraLandingFiguresDialogComponent,
  },
})
export default class MiraUnlockListComponent extends Vue {
  @Ref("figuresDialog")
  figuresDialog!: MiraLandingFiguresDialogComponent;

  @Prop({ required: true })
  groups!: MiraSectionUnlocks[];

  /** The loaded section documents, for a section's settings; a section without one has no gear. */
  @Prop({ default: () => ({}) })
  sections!: Partial<Record<MiraSection, MiraSectionDocument>>;

  /** A getter, not a field: a field is evaluated once and would not follow a theme toggle. */
  get goodColor() {
    return miraStatusColor(MiraCoverageStatus.GOOD, this.$vuetify.theme.dark);
  }

  sectionIcon(section: MiraSection): string {
    return MIRA_SECTION_ICONS[section] ?? "mdi-chart-box-outline";
  }

  metricTitle(metricId: string): string {
    const key = `mira.metrics.${metricId}.title`;
    return this.$te(key) ? this.$t(key).toString() : metricId;
  }

  metricUnlock(metricId: string): string {
    const key = `mira.metrics.${metricId}.unlock`;
    return this.$t(this.$te(key) ? key : "mira.dataQuality.unlocks.fallback").toString();
  }

  /**
   * Open the "Mehr Kennzahlen freischalten" page. Navigates through the injected `$router` with the
   * route name as a literal, so this presentational component stays out of the router's import graph:
   * importing `@/router/router` here would pull every route component into the Mira mount spec.
   */
  onShowAll() {
    this.$router.push({ name: "MiraUnlock" });
  }

  /** "Was weitere Kennzahlen freischaltet" opens the section's settings (Hans, #2610102). */
  onSettings(section: MiraSection) {
    void this.figuresDialog.show(section, this.sections, miraLandingChoice(section), mayEditMiraLandingChoice());
  }
}
